<template>
  <v-container class="ma-0 pa-0" style="overflow: hidden">
    <v-card class="pa-2 ma-0" align-items="center">
      <v-row justify="center" align="center" class="ma-1 mb-1">
        <v-spacer></v-spacer>
        <span class="subtitle">
          <b>Сверяване дата и час</b>
        </span>
        <v-spacer></v-spacer>
        <v-btn color="error" text fab small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider></v-divider>
      <v-row v-if="lastFpError" justify="center" class="ma-1">
        <span class="subtitle error--text">{{ lastFpError }}</span>
        <v-divider></v-divider>
      </v-row>
      <v-row class="ma-2 pl-3 pr-3">
        <v-col cols="3" lg="5" md="3" sm="3" xs="3" class="ma-0 pa-0 pb-1">
          <v-row>Дата ФУ:</v-row>
        </v-col>
        <v-col cols="9" lg="7" md="9" sm="9" xs="9" class="ma-0 pa-0 pb-1">
          <v-row align="end" justify="end">{{ dtDev ? dtDev.toStringWithFormat("dd.MM.yyyy hh.mm.ss") : "Неизвестна" }}</v-row>
        </v-col>
      </v-row>
      <v-row class="ma-2 pl-3 pr-3">
        <v-col cols="3" lg="5" md="3" sm="3" xs="3" class="ma-0 pa-0">
          <v-row>Система:</v-row>
        </v-col>
        <v-col cols="9" lg="7" md="9" sm="9" xs="9" class="ma-0 pa-0">
          <v-row align="end" justify="end">{{ dtPc.toStringWithFormat("dd.MM.yyyy hh.mm.ss") }}</v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="ma-2 pb-2" justify="center" align="center">
        <v-dialog ref="caldendarDialogRef" v-model="modalCalendar" :return-value.sync="rcpDate" persistent width="290px">
          <template v-slot:activator="{ on }">
            <v-row class="pa-2">
              <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="mt-2 mb-2 elevation-0" v-on="on">
                <v-icon color="#1685c9" left>mdi-clock-outline</v-icon>
                <span>Избор на дата</span>
              </v-btn>
              <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="mt-2 mb-2 elevation-0" @click="progDateTime">
                <v-icon color="#1685c9" left>mdi-clock-outline</v-icon>
                <span>Сверяване с компютъра</span>
              </v-btn>
            </v-row>
          </template>
          <v-date-picker v-if="!calendarDateSet" firstDayOfWeek="1" type="date" locale="bg" v-model="rcpDate">
            <v-row class="mr-2 ml-2" justify="end">
              <v-btn text color="#1685c9" @click="modalCalendar = false">Отказ</v-btn>
              <v-btn text color="#1685c9" @click="calendarDateSet = true">OK</v-btn>
            </v-row>
          </v-date-picker>
          <v-time-picker v-else v-model="rcpTime" use-seconds format="24hr">
            <v-row class="mr-2 ml-2" justify="end">
              <v-btn
                text
                color="#1685c9"
                @click="
                  modalCalendar = false;
                  calendarDateSet = false;
                "
                >Отказ</v-btn
              >
              <v-btn text color="#1685c9" @click="progDateTime">Програмирай</v-btn>
            </v-row>
          </v-time-picker>
        </v-dialog>
        <v-alert v-if="alertMessage != null" class="mt-3" dense color="error" dark border="left" icon="mdi-clock-outline" transition="scale-transition">{{ alertMessage }}</v-alert>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import Const from "../constants";
export default {
  data() {
    return {
      dialog: true,
      modalCalendar: false,
      calendarDateSet: false,
      dtDev: null, //new Date(),
      dtPc: new Date(),
      intervalClock: null,
      rcpTime: Date().slice(16, 24),
      rcpDate: new Date().toStringWithFormat("yyyy-MM-dd"),
      alertMessage: null,
      lastFpError: null,
    };
  },
  methods: {
    close() {
      this.fp.exitMode(Const.Modes.SetDateTime);
    },
    getFullDate(date, time) {
      var tArr = time.split(":");
      var dt = new Date(date);
      dt.setHours(Number(tArr[0]));
      dt.setMinutes(Number(tArr[1]));
      dt.setSeconds(Number(tArr[2]));
      return dt;
    },
    async progDateTime() {
      let date = this.getFullDate(this.rcpDate, this.rcpTime);
      await this.fp.executeWithLoader(async () => {
        try {
          await this.fp.SetDateTime(date);
          //this.$refs.caldendarDialogRef.save(this.rcpDate);
          this.fp.exitMode(Const.Modes.SetDateTime);
          this.fp.addMode(Const.Modes.Sales);
          this.fp.setInfoMessage("Успешно сверяване на дата и час.");
        } catch (ex) {
          this.calendarDateSet = false;
          this.modalCalendar = false;
          this.fp.handleException(ex);
          //this.alertMessage = `Грешка при сверяване: ${ex.message}`;
          //this.$refs.caldendarDialogRef.save(this.rcpDate);
        }
      }, "Сверяване на дата и час...");
    },
    async init() {
      this.intervalClock = setInterval(() => {
        this.$nextTick(() => {
          this.dtPc = new Date();
        });
      }, 1000);
      this.lastFpError = this.fp.getErrorMessage();
      try {
        this.dtDev = await this.fp.ReadDateTime();
      } catch {
        /** ignored */
      }
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    this.fp.setErrorMessage(null);
    clearInterval(this.intervalClock);
  },
};
</script>